/**
 * AI API 代理工具
 * 所有 AI API 呼叫統一透過後端代理，不再從前端直接呼叫。
 * 解決 CORS 問題並防止 API Key 暴露。
 */

import { API_CONFIG } from './config';

/**
 * 透過後端代理呼叫 AI API（SSE 串流）
 * 回傳原生 fetch Response 物件，SSE 處理邏輯與原本相同。
 *
 * @param {Array}  messages    - AI 對話訊息陣列 [{ role, content }, ...]
 * @param {string} moduleName  - 模組名稱，後端依此選擇對應的 API 與模型
 *                               可用值: 'news' | 'screener' | 'business' |
 *                                       'maininfo_fundamental' | 'maininfo_other'
 * @returns {Promise<Response>}
 */
export const callAIProxyStream = async (messages, moduleName) => {
  const url = `${API_CONFIG.baseURL}/api/gpt/proxy-stream`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify({ messages, moduleName }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};
